/**
 * Auto-generated service - DO NOT EDIT MANUALLY
 * Generated from: fax.ts
 * Run: pnpm gen
 */

import { API_METHODS } from '../constants/api-methods';
import { getApiPath } from '../path';
import { type RequestOptions, type Transport } from '../transport';

import type {
  CreateFaxRequest,
  CreateFaxResponse,
  DeleteFaxRequest,
  DeleteFaxResponse,
  GetFaxRequest,
  GetFaxResponse,
  ListFaxesRequest,
  ListFaxesResponse,
  UpdateFaxRequest,
  UpdateFaxResponse,
} from '../types/fax';

export const createFaxService = (transport: Transport) => ({
  async createFax(
    request: CreateFaxRequest,
    options: RequestOptions = {},
  ): Promise<CreateFaxResponse> {
    const { organization_id, program_id, case_record_id, ...body } = request;
    const url = getApiPath(API_METHODS.FaxService.CreateFax, {
      organization_id,
      program_id,
      case_record_id,
    });
    return transport.post<CreateFaxResponse>(url, body, options);
  },

  async getFax(request: GetFaxRequest, options: RequestOptions = {}): Promise<GetFaxResponse> {
    const { organization_id, program_id, case_record_id, fax_id } = request;
    const url = getApiPath(API_METHODS.FaxService.GetFax, {
      organization_id,
      program_id,
      case_record_id,
      fax_id,
    });
    return transport.get<GetFaxResponse>(url, options);
  },

  async listFaxes(
    request: ListFaxesRequest,
    options: RequestOptions = {},
  ): Promise<ListFaxesResponse> {
    const { organization_id, program_id, case_record_id, ...params } = request;
    const url = getApiPath(API_METHODS.FaxService.ListFaxes, {
      organization_id,
      program_id,
      case_record_id,
    });
    return transport.get<ListFaxesResponse>(url, { params, ...options });
  },

  async updateFax(
    request: UpdateFaxRequest,
    options: RequestOptions = {},
  ): Promise<UpdateFaxResponse> {
    const { organization_id, program_id, case_record_id, fax_id, ...body } = request;
    const url = getApiPath(API_METHODS.FaxService.UpdateFax, {
      organization_id,
      program_id,
      case_record_id,
      fax_id,
    });
    return transport.post<UpdateFaxResponse>(url, body, options);
  },

  async deleteFax(
    request: DeleteFaxRequest,
    options: RequestOptions = {},
  ): Promise<DeleteFaxResponse> {
    const { organization_id, program_id, case_record_id, fax_id } = request;
    const url = getApiPath(API_METHODS.FaxService.DeleteFax, {
      organization_id,
      program_id,
      case_record_id,
      fax_id,
    });
    return transport.delete<DeleteFaxResponse>(url, options);
  },
});

export type FaxService = ReturnType<typeof createFaxService>;
